import {AbstractEvent} from "@/modules/base/events";
import {Match} from "@/modules/match/entity";
import {HomeAwayType} from "../types";

export class AfterMatchChangePossessionEvent extends AbstractEvent {
  constructor(
    public match: Match,
    public possession: HomeAwayType,
  ) {
    super();
  }
}